import { Row, Col, Carousel } from "react-bootstrap";
import imgCambrdige from "../../../assets/images/logocambridge.png";
import img1 from "../../../assets/images/28.jpg"; 
import img2 from "../../../assets/images/ingles2.jpg"; 
import img3 from "../../../assets/images/ingles3.jpg"; 
import MenuInteremedio from "./menuInteremedioNiveles";

function InglesIntensivo() {
    return (
        <div>
            <Row className="p-3 mb-4 d-flex align-items-center text-justify lead bg-light text-dark rounded-4 shadow" data-aos="fade-up">
                <Col md={8}>
                    <h1 className="display-4 text-primary fw-bold border-bottom pb-2">Inglés Intensivo</h1>
                    <h5 className="  text-white text-muted mb-4">Preparación para Exámenes Internacionales</h5>
                </Col>
                <Col md={4} className="d-flex justify-content-md-end justify-content-center align-items-center">
                    <img src={imgCambrdige} alt="Logo Cambridge" style={{ maxHeight: 150 }} />
                </Col>
            </Row>
            <div />
            <Carousel fade className="mb-5">
                <Carousel.Item>
                    <img className="d-block w-100" src={img1} alt="Ingles Intensivo 1" style={{ objectFit: "cover", height: "500px" }} />
                    <Carousel.Caption>
                        <h3 className="text-white">Inglés Intensivo en Acción</h3>
                        <p className="text-white">Experiencia inmersiva en el aprendizaje del idioma.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img className="d-block w-100" src={img2} alt="Ingles Intensivo 2" style={{ objectFit: "cover", height: "500px" }} />
                    <Carousel.Caption>
                        <h3 className="text-white">Preparación para Exámenes Internacionales</h3>
                        <p className="text-white">Certificación Cambridge para un futuro prometedor.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img className="d-block w-100" src={img3} alt="Ingles Intensivo 3" style={{ objectFit: "cover", height: "500px" }} />
                    <Carousel.Caption>
                        <h3 className="text-white">Una Enseñanza de Calidad</h3>
                        <p className="text-white">Clases dinámicas que promueven el aprendizaje natural.</p>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>

            <MenuInteremedio />
            <div className="m-3">
                <Row className="justify-content-center " >
                    <Col lg={9} xl={12} >
                        <p className="fw-bold lead lh-lg text-justify lead bg-light text-dark p-5 rounded-4 shadow text-ingles" data-aos="fade-up">
                            En el área de Inglés, los alumnos comienzan su aprendizaje del idioma en el jardín de infantes (Nivel Inicial) con medio turno de inglés. A partir del primer grado y durante toda la primaria y secundaria, tienen 12 horas semanales de inglés intensivo, lo que les permite acceder a exámenes internacionales de la Universidad de Cambridge y obtener un dominio experto (escrito y oral) del inglés.
                        </p>
                        <p className="fw-bold lead lh-lg text-justify lead bg-light text-dark p-5 rounded-4 shadow text-ingles" data-aos="fade-up">
                            Consideramos esta competencia esencial como "Lingua Franca" o idioma universal para el futuro. Esto les permitirá acceder al campo del estudio y del trabajo nacional e internacional (en un mundo cada vez más interrelacionado), superando las barreras idiomáticas. Todo ello sin perder el enfoque en lo nacional, pues una definida identidad ayudará a nuestros futuros jóvenes a manejarse con seguridad en un mundo con nuevas fronteras.
                        </p>
                        <p className="fw-bold lead lh-lg text-justify lead bg-light text-dark p-5 rounded-4 shadow text-ingles" data-aos="fade-up">
                            La enseñanza bilingüe no solo permite abordar una estructura lógica y lingüística nueva, sino también trabajar contenidos con un vocabulario más amplio y desde los distintos campos del saber. Se promueven competencias de vocabulario, ortografía, lectura, entre otras. Además, la dimensión lúdica y el teatro contribuyen a una adquisición más natural del idioma. En el Colegio Santo Tomás, el inglés se adquiere principalmente por inmersión, de manera natural, casi como se aprende la lengua materna.
                        </p>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default InglesIntensivo;
